import BonusActiveItem from "./BonusActiveItem.jsx";
import BonusActivePanelLotsWagerContent from "./BonusActivePanelLotsWagerContent.jsx";
import { memo } from "react";
import { BonusInfoIconTooltipStyled } from "../../../../components/InfoIcon/styled/InfoIconStyled.js";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

const BonusWelcomeTerms = memo(({style}) => {
    const {getLangPath} = useLangContext();
    return (
            <BonusInfoIconTooltipStyled style={style}>
                <ol dangerouslySetInnerHTML={{__html: getLangPath('bonuses.terms')}}/>
            </BonusInfoIconTooltipStyled>
    );
});

function BonusWelcome(props) {
    const {bonus, flat} = props;
    return <BonusActiveItem bonus={bonus} flat={flat} infoComponent={<BonusWelcomeTerms/>}>
        <BonusActivePanelLotsWagerContent bonus={bonus} flat={flat}/>
    </BonusActiveItem>;
}

export default BonusWelcome;
